import { Injectable, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core'
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';


import { Address } from './addressinterface';
import { AddressModel } from './address_model.model';
import { GlobalService } from '../general/global.service';
import { CommonService } from '../general/common.service';
import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';

declare var require: any;

@Injectable({
	providedIn: 'root',
})
@UntilDestroy()

export class AddressService implements Resolve<any> {
	routeParams: any;

	private allItemsSource = new BehaviorSubject<Address[]>([]);
	allItems = this.allItemsSource.asObservable();

	private addressItemsSource = new BehaviorSubject<any>([]);
	addressItems = this.addressItemsSource.asObservable();

	private addressCityItemsSource = new BehaviorSubject<any>([]);
	addressCityItems = this.addressCityItemsSource.asObservable();

	private addAddressSource = new BehaviorSubject<any>([]);
	addAddress = this.addAddressSource.asObservable();

	private _unsubscribeAll: Subject<any>;

	constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, private globalService: GlobalService,
		private commonService: CommonService, private toast: ToastrService,) {
		this._unsubscribeAll = new Subject();
	}

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
		this.routeParams = route.params;
		return new Promise((resolve, reject) => {
			Promise.all([
				this.getValidateAccessKey(),
				this.getAddressData()
			])
				.then(() => {
					resolve(null);
				}, reject
				);
		});
	}

	unSubscribe() {
		// console.log('UnSubscribed AgentService');
	}

	unSubscribeFilter() {
		// console.log('UnSubscribed Filters on AgentService');
	}


	changeAllItems(allItems: Address[]) {
		this.allItemsSource.next(allItems);
	}

	changeAddressItems(allItems: any) {
		this.addressItemsSource.next(allItems);
	}

	changeCityItems(allItems: any) {
		this.addressCityItemsSource.next(allItems);
	}

	changeAddItems(allItems: any) {
		this.addAddressSource.next(allItems);
	}

	getValidateAccessKey() {
		if (this.routeParams && this.routeParams.addressToken && this.routeParams.addressToken.length > 0) {
			;
			var params = {
				"accessKey": this.routeParams.addressToken
			}
			this.commonService.getItem('https://app.ai-octopus.com/apime/address/validateAccessKey', params)
				.pipe(untilDestroyed(this, 'unSubscribe'))
				.subscribe(data => {
					if (data.success) {
						// localStorage.setItem('token', this.routeParams.addressToken)
						// if (data && data.additional && data.additional.BrandInfo && data.additional.BrandInfo.length > 0) {
						// 	var brandInfo = data.additional.BrandInfo;

						// 	data.data.forEach(branch => {
						// 		if (branch.brand_id && branch.brand_id.length > 0) {
						// 			brandInfo.forEach(brand => {
						// 				if (brand._id == branch.brand_id) {
						// 					branch["brand"] = brand;
						// 				}
						// 			});
						// 		}
						// 	});
						// }
						this.changeAllItems(JSON.parse(data.data));
					} else {
						this.changeAllItems(data);
					}
				},
					error => {
						console.log('Error ::' + error);
						this.toast.error('Something Went Wrong !!!');
						setTimeout(() => {
							if (typeof document !== 'undefined') {
								document.location.href = "https://ai-octopus.com/"
							}
						}, 2000);
					}
				);
		}

	}

	getAddressData() {
		if (this.routeParams && this.routeParams.addressToken && this.routeParams.addressToken.length > 0) {
			var params = {
				"accessKey": this.routeParams.addressToken
			}
			this.commonService.getItem('https://app.ai-octopus.com/apime/address/addresslist', params)
				.pipe(untilDestroyed(this, 'unSubscribe'))
				.subscribe(data => {
					if (data.success) {

						this.changeAddressItems(data.data);
					} else {
						if (data.errors.message) {
							if (data.errors.message == 'Accesskey is Invalid') {
								this.router.navigate(['/page-expired']);
								this.toast.error(data.errors.message);
							} else {
								this.toast.error(data.errors.message);
							}
						} else {
							this.toast.error('Something Went Wrong !!!');
						}
						this.changeAddressItems([]);
					}
				},
					error => {
						console.log('Error ::' + error);
						this.toast.error('Something Went Wrong !!!');
						setTimeout(() => {
							if (typeof document !== 'undefined') {
								document.location.href = "https://ai-octopus.com/"
							}
						}, 1000);
					}
				);
		}

	}

	getCityData(params: any) {
		if (this.routeParams && this.routeParams.addressToken && this.routeParams.addressToken.length > 0) {
			params["accessKey"] = this.routeParams.addressToken
			this.commonService.getItem('https://app.ai-octopus.com/apime/address/cities', params)
				.pipe(untilDestroyed(this, 'unSubscribe'))
				.subscribe(data => {
					if (data.success) {
						this.changeCityItems(data.data);
					} else {
						if (data.errors.message) {
							if (data.errors.message == 'Accesskey is Invalid') {
								this.router.navigate(['/page-expired']);
								this.toast.error(data.errors.message);
							} else {
								this.toast.error(data.errors.message);
							}
						} else {
							this.toast.error('Something Went Wrong !!!');
						}
						// setTimeout(() => {
						// 	if (typeof document !== 'undefined') {
						// 		document.location.href = "https://ai-octopus.com/"
						// 	}
						// }, 1000);
						this.changeCityItems([]);
					}
				},
					error => {
						console.log('Error ::' + error);
						this.toast.error('Something Went Wrong !!!');
						setTimeout(() => {
							if (typeof document !== 'undefined') {
								document.location.href = "https://ai-octopus.com/"
							}
						}, 1000);
					}
				);
		}

	}

	store(params: any) {
		if (this.routeParams && this.routeParams.addressToken && this.routeParams.addressToken.length > 0) {
			params["accessKey"] = this.routeParams.addressToken
			this.commonService.getItem('https://app.ai-octopus.com/apime/address/add', params)
				.pipe(untilDestroyed(this, 'unSubscribe'))
				.subscribe(data => {
					if (data.success) {
						this.changeAddItems({ success: true });
					} else {
						if (data.errors.message) {
							if (data.errors.message == 'Accesskey is Invalid') {
								this.router.navigate(['/page-expired']);
								this.toast.error(data.errors.message);
							} else {
								this.toast.error(data.errors.message);
							}
						} else {
							this.toast.error('Something Went Wrong !!!');
						}
					}
				},
					error => {
						console.log('Error ::' + error);
						this.toast.error('Something Went Wrong !!!');
						this.changeCityItems([{ success: true }]);
					}
				);
		}

	}

	// store(url, data: any) {
	// 	this.commonService.storeItem(url, data, true, 'optionOne')
	// 		.pipe(untilDestroyed(this, 'unSubscribe'))
	// 		.subscribe(res => {
	// 			if (res.success) {
	// 				if (res && res.data && res.data.brandInfo) {
	// 					res.data["brand"] = res.data.brandInfo;
	// 				}
	// 				this.concatItem(res.data);
	// 				this.changeItem(res.data);
	// 				this.alert('Success', "Created Successfully !!!");
	// 			} else {
	// 				this.alertService.webErrorShow(res);
	// 			}
	// 		},
	// 			error => {
	// 				console.log('Error ::' + error);
	// 				this.alert('Danger', 'Something Wrong. Try after Sometimes !!!');
	// 			}
	// 		);
	// }

	// update(url, data: any): void {
	// 	this.commonService.storeItem(url, data, true, 'optionOne')
	// 		.pipe(untilDestroyed(this, 'unSubscribe'))
	// 		.subscribe(res => {
	// 			if (res.success) {
	// 				if (res && res.data && res.data.brandInfo) {
	// 					res.data["brand"] = res.data.brandInfo;
	// 				}
	// 				this.changeItem(res.data);
	// 				this.changeAllItemsByItem(res.data);

	// 				this.alert('Success', "Updated Successfully !!!");

	// 			} else {
	// 				this.alertService.webErrorShow(res);
	// 			}
	// 		},
	// 			error => {
	// 				console.log('Error ::' + error);
	// 				this.alert('Danger', 'Something Wrong. Try after Sometimes !!!');
	// 			}
	// 		);
	// }

	getPosition(): Promise<any> {
		return new Promise((resolve, reject) => {
			if (isPlatformBrowser(this.platformId)) {
				if ('geolocation' in navigator) {
					navigator.geolocation.getCurrentPosition(
						(resp) => {
							// Successfully got the position
							resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
							// 		 console.log('Latitude:', resp.coords.latitude);
							// console.log('Longitude:', resp.coords.longitude);
						},
						(err) => {
							// Handle errors (e.g., permission denied, position unavailable, etc.)
							reject('Error retrieving geolocation: ' + err.message);
						},
						{
							enableHighAccuracy: true,  // Request high accuracy
							timeout: 15000,  // 10 seconds timeout
							maximumAge: 0,   // Prevent using cached position
						}
					);
				} else {
					reject('Geolocation is not supported by this browser.');
				}
			} else {
				reject('Not in browser environment.');
			}
		});
	}




}
